module.exports = __webpack_public_path__ + "img/info-ico-custom.8ff35bc0.png";